export class LoanApplicationRoleAssignmentsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanRoleAssignmentsHistory({ applicationId, companyId }) {
    return this.#http.get(
      `/api/companies/${companyId}/applications/${applicationId}/loanRoleAssignments/history`,
    );
  }
}
